import $ from 'jquery';

export default function () {

    $('#defaultModal').on('show.bs.modal', function (event) {

        let button = $(event.relatedTarget);
        let title = button.parent().find('.modal-title');
        let text = button.parent().find('.modal-text');

        if(title.length && title.html().length > 0) {
            $('#defaultModalLabel').html(title.html());
        }
        if(text.length && text.html().length > 0) {
            $('#defaultModalText').html(text.html());
        }

    });

}
